[
    {
      "2019": 1.951768211,
      "2020": 2.415130941,
      "2021": 7.226063074,
      "2022": 9.265515516,
      "country_name": "Algeria",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "DZA"
    },
    {
      "2019": 17.07970441,
      "2020": 22.27156431,
      "2021": 25.75426565,
      "2022": "",
      "country_name": "Angola",
      "Extra_notes": "",
      "last_full_year": 2021,
      "country_code": "AGO"
    },
    {
      "2019": -0.7050266345,
      "2020": 3.022721197,
      "2021": 1.733539627,
      "2022": 1.350778636,
      "country_name": "Benin",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "BEN"
    },
    {
      "2019": 2.772864429,
      "2020": 1.890359168,
      "2021": 7.240977656,
      "2022": 11.66556748,
      "country_name": "Botswana",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "BWA"
    },
    {
      "2019": -3.23338934,
      "2020": 1.884439938,
      "2021": 3.653532872,
      "2022": 14.29023543,
      "country_name": "Burkina Faso",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "BFA"
    },
    {
      "2019": -0.6867721708,
      "2020": 7.321106434,
      "2021": 8.404538451,
      "2022": 18.80087867,
      "country_name": "Burundi",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "BDI"
    },
    {
      "2019": 1.106666743,
      "2020": 0.6057958084,
      "2021": 1.862152975,
      "2022": "",
      "country_name": "Cabo Verde",
      "Extra_notes": "",
      "last_full_year": 2021,
      "country_code": "CPV"
    },
    {
      "2019": 2.452802141,
      "2020": 2.437608822,
      "2021": 2.271857625,
      "2022": 6.247677133,
      "country_name": "Cameroon",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "CMR"
    },
    {
      "2019": 2.685373553,
      "2020": 1.710156595,
      "2021": 4.259364175,
      "2022": 5.583167352,
      "country_name": "Central African Republic",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "CAF"
    },
    {
      "2019": -0.9719391754,
      "2020": 4.464144372,
      "2021": -0.7728443704,
      "2022": 5.788026878,
      "country_name": "Chad",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "TCD"
    },
    {
      "2019": "#N/A",
      "2020": "#N/A",
      "2021": "#N/A",
      "2022": "#N/A",
      "country_name": "Comoros",
      "Extra_notes": "",
      "last_full_year": "",
      "country_code": "COM"
    },
    {
      "2019": -1.10686344,
      "2020": 2.425006568,
      "2021": 4.091951897,
      "2022": 5.276167243,
      "country_name": "Côte d'Ivoire",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "CIV"
    },
    {
      "2019": "#N/A",
      "2020": "#N/A",
      "2021": "#N/A",
      "2022": "#N/A",
      "country_name": "Democratic Republic of the Congo",
      "Extra_notes": "",
      "last_full_year": "",
      "country_code": "COD"
    },
    {
      "2019": 3.319253727,
      "2020": 1.777407838,
      "2021": 1.181917753,
      "2022": 5.17980848,
      "country_name": "Djibouti",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "DJI"
    },
    {
      "2019": 9.152799593,
      "2020": 5.04493289,
      "2021": 5.214049405,
      "2022": 13.89566098,
      "country_name": "Egypt",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "EGY"
    },
    {
      "2019": 1.53027529,
      "2020": 4.766695239,
      "2021": -0.09710076646,
      "2022": 4.786717047,
      "country_name": "Equatorial Guinea",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GNQ"
    },
    {
      "2019": 2.598016203,
      "2020": "",
      "2021": "",
      "2022": "",
      "country_name": "Eswatini",
      "Extra_notes": "",
      "last_full_year": 2019,
      "country_code": "SWZ"
    },
    {
      "2019": 15.80963217,
      "2020": 20.35634686,
      "2021": 26.83952216,
      "2022": "",
      "country_name": "Ethiopia",
      "Extra_notes": "",
      "last_full_year": 2021,
      "country_code": "ETH"
    },
    {
      "2019": 2.464567562,
      "2020": 1.352761107,
      "2021": 1.086907465,
      "2022": 4.231247983,
      "country_name": "Gabon",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GAB"
    },
    {
      "2019": 7.143640033,
      "2020": 9.887289563,
      "2021": 9.971088675,
      "2022": 31.2558951,
      "country_name": "Ghana",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GHA"
    },
    {
      "2019": 9.470010393,
      "2020": 10.60162034,
      "2021": 12.59728826,
      "2022": 10.493041,
      "country_name": "Guinea",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GIN"
    },
    {
      "2019": 0.2466002681,
      "2020": 1.140009394,
      "2021": 2.242488796,
      "2022": 9.393838775,
      "country_name": "Guinea-Bissau",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GNB"
    },
    {
      "2019": 5.235859994,
      "2020": 5.404814672,
      "2021": 6.110909164,
      "2022": 7.656874561,
      "country_name": "Kenya",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "KEN"
    },
    {
      "2019": 5.187083592,
      "2020": 4.978096763,
      "2021": 6.04774592,
      "2022": 8.271803899,
      "country_name": "Lesotho",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "LSO"
    },
    {
      "2019": "#N/A",
      "2020": "#N/A",
      "2021": "#N/A",
      "2022": "#N/A",
      "country_name": "Liberia",
      "Extra_notes": "",
      "last_full_year": "",
      "country_code": "LBR"
    },
    {
      "2019": "#N/A",
      "2020": "#N/A",
      "2021": "#N/A",
      "2022": "#N/A",
      "country_name": "Libya",
      "Extra_notes": "",
      "last_full_year": "",
      "country_code": "LBY"
    },
    {
      "2019": 5.610514415,
      "2020": 4.201793122,
      "2021": 5.812251188,
      "2022": 8.16059032,
      "country_name": "Madagascar",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MDG"
    },
    {
      "2019": 9.370836056,
      "2020": 8.625514697,
      "2021": 9.330144108,
      "2022": 20.95396973,
      "country_name": "Malawi",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MWI"
    },
    {
      "2019": -1.658266948,
      "2020": 0.4380889403,
      "2021": 3.925602831,
      "2022": "",
      "country_name": "Mali",
      "Extra_notes": "",
      "last_full_year": 2021,
      "country_code": "MLI"
    },
    {
      "2019": 2.300092621,
      "2020": 2.385694885,
      "2021": 3.565164847,
      "2022": 9.525266286,
      "country_name": "Mauritania",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MRT"
    },
    {
      "2019": 0.4056551903,
      "2020": 2.580800772,
      "2021": 4.028528882,
      "2022": 10.77375122,
      "country_name": "Mauritius",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MUS"
    },
    {
      "2019": 0.3033860366,
      "2020": 0.7059686613,
      "2021": 1.40195884,
      "2022": 6.657042028,
      "country_name": "Morocco",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MAR"
    },
    {
      "2019": 2.802703079,
      "2020": 3.483935675,
      "2021": 6.40847653,
      "2022": 10.27940181,
      "country_name": "Mozambique",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "MOZ"
    },
    {
      "2019": 3.722394144,
      "2020": 2.209382369,
      "2021": 3.616905301,
      "2022": 6.081281141,
      "country_name": "Namibia",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "NAM"
    },
    {
      "2019": -2.489792651,
      "2020": 2.89819376,
      "2021": 3.837868028,
      "2022": 4.226217919,
      "country_name": "Niger",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "NER"
    },
    {
      "2019": 11.39642234,
      "2020": 13.24602343,
      "2021": 16.95284572,
      "2022": "",
      "country_name": "Nigeria",
      "Extra_notes": "",
      "last_full_year": 2021,
      "country_code": "NGA"
    },
    {
      "2019": 2.206073058,
      "2020": 1.795371471,
      "2021": 1.715642755,
      "2022": 3.043443347,
      "country_name": "Republic of Congo",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "COG"
    },
    {
      "2019": 3.34787655,
      "2020": 9.850399023,
      "2021": -0.3913467483,
      "2022": 17.68920956,
      "country_name": "Rwanda",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "RWA"
    },
    {
      "2019": 7.720245252,
      "2020": 9.819327915,
      "2021": 8.137770384,
      "2022": 18.00563511,
      "country_name": "São Tomé and Príncipe",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "STP"
    },
    {
      "2019": 1.760111512,
      "2020": 2.543146857,
      "2021": 2.180322781,
      "2022": 9.696818991,
      "country_name": "Senegal",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "SEN"
    },
    {
      "2019": 2.074764365,
      "2020": 8.276858114,
      "2021": "",
      "2022": "",
      "country_name": "Seychelles",
      "Extra_notes": "",
      "last_full_year": 2020,
      "country_code": "SYC"
    },
    {
      "2019": 14.80499909,
      "2020": 13.44687111,
      "2021": 11.87395888,
      "2022": 27.20828838,
      "country_name": "Sierra Leone",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "SLE"
    },
    {
      "2019": 4.708556589,
      "2020": 4.113129818,
      "2021": 4.624900389,
      "2022": 6.779276233,
      "country_name": "Somalia",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "SOM"
    },
    {
      "2019": 4.12024587,
      "2020": 3.210035975,
      "2021": 4.611672178,
      "2022": 7.039726613,
      "country_name": "South Africa",
      "Extra_notes": "Note: StatsSA reports monthly inflation using urban areas only. These numbers are for national CPI change.",
      "last_full_year": 2022,
      "country_code": "ZAF"
    },
    {
      "2019": 87.24136415,
      "2020": 29.67584355,
      "2021": 10.51671583,
      "2022": -6.687320942,
      "country_name": "South Sudan",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "SSD"
    },
    {
      "2019": 50.9940515,
      "2020": 150.3227239,
      "2021": 382.8159983,
      "2022": 138.8084602,
      "country_name": "Sudan",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "SDN"
    },
    {
      "2019": 3.46428058,
      "2020": 3.290290628,
      "2021": 3.690919588,
      "2022": 4.350272043,
      "country_name": "Tanzania",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "TZA"
    },
    {
      "2019": 7.115676256,
      "2020": 5.931276366,
      "2021": 7.370347589,
      "2022": 11.51311984,
      "country_name": "The Gambia",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "GMB"
    },
    {
      "2019": 0.6746527701,
      "2020": 1.699284633,
      "2021": 4.186215065,
      "2022": 7.967573616,
      "country_name": "Togo",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "TGO"
    },
    {
      "2019": 6.720075329,
      "2020": 5.634151159,
      "2021": 5.706350208,
      "2022": 8.306461244,
      "country_name": "Tunisia",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "TUN"
    },
    {
      "2019": 2.867588034,
      "2020": 3.313322895,
      "2021": 2.204572048,
      "2022": 7.19578886,
      "country_name": "Uganda",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "UGA"
    },
    {
      "2019": 9.150316443,
      "2020": 15.73306047,
      "2021": 22.02076762,
      "2022": 10.99320392,
      "country_name": "Zambia",
      "Extra_notes": "",
      "last_full_year": 2022,
      "country_code": "ZMB"
    },
    {
      "2019": 255.3049908,
      "2020": 557.2018174,
      "2021": 98.54610509,
      "2022": 104.7051706,
      "country_name": "Zimbabwe",
      "Extra_notes": "Note: Zimbabwe has two inflation rates due to its dual currency. This is for prices in Zimbabwe Dollars.",
      "last_full_year": 2022,
      "country_code": "ZWE"
    }
  ]